import api from 'data/api';

export const loadManagers = api('GET /api/mobile/lookups/managers');
